
        var result = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js!./org-vdc.wizard.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/org-vdc.wizard.scss
// module id = 3Xvc
// module chunks = 0